import Styled, { css } from 'styled-components';

import { fadeInOut, ITransitionStates } from '../Animations/Animations';
import { Box } from '../Layout/Box';
import { cssDeclaration } from '../Utils/Styles/cssDeclaration';

import { TRANSITION_DURATION } from './Notification.util';

export const Notification = Styled(Box) <{ variant: string } & ITransitionStates>`
  ${ ({ variant, theme: { themeTwo }, theme: { themeTwo: { notification } } }) => {
    if (notification) {
      return css`
          ${ cssDeclaration(themeTwo, 'background-color', notification.variant[variant].backgroundColor || '') };
          ${ cssDeclaration(themeTwo, 'border', notification.variant[variant].border) };
          ${ cssDeclaration(themeTwo, 'box-shadow', notification.variant[variant].shadow) };
          ${ cssDeclaration(themeTwo, 'padding', notification.variant[variant].padding) };
        `;
    }
  }}
  width: 100%;
  justify-content: space-between;
  transition: opacity ${ TRANSITION_DURATION }ms ease-out;
  ${ fadeInOut }
`;

export const CloseButton = Styled.button`
  ${ ({ theme: { themeTwo } }) => {
    const { notification } = themeTwo;
    const closeIcon = notification && notification.closeIcon;

    return css`
      /* padding */ ${ closeIcon && cssDeclaration(themeTwo, 'padding', closeIcon.padding) }
    `;
  }}
`;
